/**
 * Finery markets management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

export interface FineryMarketsCounterparty {
  id?: number;
  accountId?: number;
  account?: Account;
  fineryOwnGrossLimit?: number;
  fineryOwnLimitUtilization?: number;
  fineryOwnEquity?: number;
  fineryMutualGrossLimit?: number;
  fineryMutualLimitUtilization?: number;
  fineryMutualEquity?: number;
  ownTradingEnabled?: boolean;
  mutualTradingEnabled?: boolean;
  deactivated?: boolean;
}
